import posed from "react-pose";

const FadeUp = posed.div({
    preEnter: {
        y: "5vh",
        opacity: 0,
        transition: {
            ease: [0.25, 0.46, 0.45, 0.94]
        }
    },
    enter: {
        y: "0",
        opacity: 1,
        transition: {
            ease: [0.25, 0.46, 0.45, 0.94]
        }
    },
    exit: {
        y: "5vh",
        opacity: 0,
        transition: {
            ease: [0.25, 0.46, 0.45, 0.94]
        }
    }
});

export default FadeUp;



// WEBPACK FOOTER //
// ./src/scripts/components/transitions/FadeUp.js